import logo from './logo.svg'

export const theme = {
  color: {
    primary: "#003781",
    primaryHover: "#001b40",
  },
  logoImage: logo,
  backend: "https://humanitas-versand.epaper-publishing-one.de/",
  directory: "/kiosk",
  header: {
    customer: "",
    title: "Humanitas Kataloge"
  },
  info: [
    {
      text: 'Impressum',
      link: 'https://www.humanitas-versand.de/Impressum'
    },
    {
      text: 'Datenschutz',
      link: 'https://www.humanitas-versand.de/Datenschutz'
    },
    {
      text: 'AGB',
      link: 'https://www.humanitas-versand.de/Allgemeine-Gesch%c3%a4ftsbedingungen'
    }
  ]
};